import Toggle from "~/common/components/Toggle/Toggle";
import { useState } from "react";
import instance from "~/utils/i18n";

const originalLanguage = window.SCHA.config.language;

export const DebugLanguageToggle = () => {
  const [debugEnabled, setDebugEnabled] = useState(false);

  return (
    <div className="scha__header__language-toggle">
      <Toggle
        checked={debugEnabled}
        onCheck={(newVal) => {
          setDebugEnabled(newVal);
          instance.changeLanguage(newVal ? "cimode" : originalLanguage);
        }}
      />
    </div>
  );
};
